import React from 'react';
import PropTypes from 'prop-types';
import { store } from '../../store';
import { fromJS } from 'immutable';
import Search from './Search';
import Location from './Location';
import { setMessage } from '../../actions/systemMessage';
import Modal from 'react-modal';

export default class DesktopSearch extends React.Component {
  state = {
    showCreate: false,
    showAdmin: false,
    searchVendors: fromJS([])
  }

  closeModal = () => {
    this.setState({ showAdmin: false });
  }

  componentWillMount() {
    this.panelSearchStyles = {};
  }

  hiddenVendors() {
    this.props._merchant.hiddenVendors()
      .then(res => this.setState({ showAdmin: true }));
  }

  onVendorSearchChange = event  => {
    this.setState({ searchVendors: this.props._merchant.adminVendorSearch(event.target.value)});
  }

  reviewVendor(vendor_id) {
    const vendor = this.props.entities.get('vendors').get(vendor_id);

    this.props._customer
      .customerAdminTakeOverVendor(
        vendor_id,
        vendor.get('claimed'),
        vendor.get('hidden'),
        true
      )
      .then(res => this.closeModal());
  }

  setTerms(value) {
    this.setState({ terms: value });
  }

  setAdmin = () => {
    const merchant = this.props.entities
      .get('merchant')
      .find(m => m.vendor_id === this.props.search.get('selectedMerchantId'));

    if (!merchant) return store.dispatch(setMessage('error', 'Oops, something went wrong, please try to admin the merchant again.'));

    return this.props._customer
      .customerAdminTakeOverVendor(merchant.get('vendor_id'), merchant.vendor.get('claimed'));
  }

  _search = () => {
    this.props._search.searchSubmit();
  }

  _showPanelSearch(bool) {
    this.setState({ panelSearch: !this.state.panelSearch });
  }

  render() {
    const { auth, customer } = this.props;

    let types = {
      dashboard: (
        <div className="container">
          <Modal
            isOpen={this.state.showAdmin}
            className="modal-dialog"
            style={{
              overlay: {
                zIndex: 1100,
                backgroundColor: 'rgba(12, 10, 10, 0.75)'
              }
            }}
            contentLabel="Vendors Pending Approval">
              <div className="modal-content">
                <div>
                  <button type="button" className="close" onMouseDown={this.closeModal}>
                    <span aria-hidden="true">&times;</span>
                    <span className="sr-only">Close</span>
                  </button>
                </div>
                <div className="modal-body text-center">
                  <div>
                    <input type="text" name="vendor_search" onChange={this.onVendorSearchChange} />
                  </div>
                  <ul>
                    {this.state.searchVendors.size > 0 ?
                      this.state.searchVendors.valueSeq().map(v =>
                        <li onClick={ () => this.reviewVendor(v.id) } key={v.id}>{v.name}</li>) :
                      this.props.entities.get('vendors').valueSeq().map(v =>
                        <li onClick={ () => this.reviewVendor(v.id) } key={v.id}>{v.name}</li>)}
                  </ul>
                </div>
              </div>
          </Modal>

          <div className="row">
            <div className="col-md-12">
              <div className="col-md-4 pull-left" style={{ padding: 0 }}>
                <Search {...this.props}
                  setTerms={this.setTerms.bind(this)}
                  placeholder="Find your business"
                  doSuggestions={false}/>
              </div>
              <div className="col-md-4 pull-left" style={{ padding: 0 }}>
                <Location {...this.props}
                  placeholder='In City, State, USA' />
              </div>
              <div className="pull-left" style={{ padding: 0 }}>
                <button
                  onClick={this._search}>
                  Claim Your Listing
                </button>
                {auth.get('user').get('scope') === 'global.admin' &&
                  <button onClick={this.setAdmin} style={{ margin: '0 0 0 4px' }}>
                    {customer.get('loading').get('vendors') && <span>
                      <i className="fa fa-circle-o-notch slow-spin" aria-hidden="true"></i>
                      <span className="sr-only">Loading...</span>
                    </span>}
                    {!customer.get('loading').get('vendors') && <span>Admin</span>}
                  </button>}
                {auth.get('user').get('scope') === 'global.admin' &&
                  <button type="button" onClick={this.hiddenVendors.bind(this)} style={{ margin: '0 0 0 4px' }}>
                    Pending Vendors
                  </button>}
              </div>
            </div>

            {!this.props.auth.get('user').get('isLoggedIn') && <div className='col-md-12'>
              <p>Already have an account? <a className='white-link' onClick={() => this.props._auth.toggleAuthenticationModal()}> Sign in <i className='fa fa-angle-right'/></a></p>
            </div>}
          </div>
        </div>
      )
    };

    return types[this.props.type];
  }
}

DesktopSearch.defaultProps = {
  type: 'dashboard'
};

DesktopSearch.propTypes = {
  search: PropTypes.object.isRequired,
  searchForMerchant: PropTypes.func,
  type: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Search/DesktopSearch.js